module.exports = __webpack_public_path__ + "static/media/right-guy.5101ff71.png";